import React, { Children, ReactElement, ReactNode, isValidElement } from 'react'
import { Box, SxProps, Theme } from '@mui/material'
import SectionTitle from '../form/SectionTitle'

export const sectionSx: SxProps<Theme> = (theme) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  border: `0.1rem solid ${theme.palette.header}`,
  borderRadius: `${theme.shape.borderRadius}px`,
  p: 2,
  mb: 2,
  width: '100%',
  '& + &': {
    mt: 2,
  },
})

interface SectionProps {
  children: ReactNode
  sx?: SxProps<Theme>
}

const withFirstSectionTitleMarginRemoved = (children: ReactNode): ReactNode => {
  const childArray = Children.toArray(children)
  if (childArray.length === 0) return children

  const firstChild = childArray[0]
  if (!isValidElement(firstChild) || firstChild.type !== SectionTitle) return children

  const sectionTitle = firstChild as ReactElement<{ isFirst?: boolean }>

  if (sectionTitle.props.isFirst === true) return children

  return [React.cloneElement(sectionTitle, { isFirst: true }), ...childArray.slice(1)]
}

export const Section: React.FC<SectionProps> = ({ children, sx }) => (
  <Box sx={sx ? [sectionSx, sx] : sectionSx}>{withFirstSectionTitleMarginRemoved(children)}</Box>
)
